import React from 'react';

import { TopLevelStats } from 'ui/shared/topLevelStats/TopLevelStats';

const TopBar = () => {
  return (
    <TopLevelStats
      latestBlock={ 123456 }
      showBlockData={ false }
    />
  );
};

export default React.memo(TopBar);
